import React, { useState, useEffect } from "react";
import "../orders/orders.scss";
import Header from "../header/Header";
import List from "../../../components/list/List";
import { useHistory } from "react-router-dom";
import Titlebar from "../../../components/titlebar/Titlebar";
import { getUserList } from "../../../utils/apis/services/api";
import Pagination from "react-js-pagination";
import ContentLoader from "react-content-loader";
import translate from "../../../utils/locale/language";
import { setPageSelection, getPageSelection } from "../../../../src/utils/common";

const User = () => {
  const history = useHistory();
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [activePage, setPage] = useState(1);
  const [usersList, setUsersList] = useState([]);
  const [requestListTmpUsers, setRequestListTmpUsers] = useState({ results: [], totalCount: 0 });

  const mapUserItem = (item) => ({
    id: item?.id,
    full_name: item?.full_name || "",
    email: item?.email || "",
    phone_number: item?.phone_number || "",
    is_active: !!item?.is_active,
    profile_image: item?.profile_image || item?.profile_image_url || ""
  });

  const getUsers = async (pageNumber = 1) => {
    const page = pageNumber || getPageSelection() || 1;
    setPageSelection(page);
    setPage(page);
    setLoading(true);
    let result = await getUserList(page);
    setLoading(false);
    let data = result?.data?.ResponseData?.results || [];
    let mapped = Array.isArray(data) ? data.map(mapUserItem) : [];
    let total = Number(result?.data?.ResponseData?.count) || mapped.length || 0;
    setUsersList(mapped);
    setRequestListTmpUsers({ results: mapped, totalCount: total });
    setCount(total);
  };

  useEffect(() => {
    if (getPageSelection()) {
      getUsers(getPageSelection());
    } else {
      setPageSelection(1);
      getUsers(1);
    }
  }, []);

  const updateInput = (value) => {
    setInput(value);
    const baseArr = requestListTmpUsers?.results || [];
    const baseTotal = requestListTmpUsers?.totalCount ?? baseArr.length;
    if (!value) {
      setUsersList(baseArr);
      setCount(baseTotal);
      return;
    }
    const q = value.toLowerCase();
    const filtered = baseArr.filter((u) => {
      return (
        String(u?.full_name || "").toLowerCase().includes(q) ||
        String(u?.email || "").toLowerCase().includes(q) ||
        String(u?.phone_number || "").toLowerCase().includes(q) ||
        String(u?.id || "").toLowerCase().includes(q)
      );
    });
    setUsersList(filtered);
    setCount(filtered.length);
  };

  const handlePageChange = (pageNumber) => {
    setPageSelection(pageNumber);
    setPage(pageNumber);
    getUsers(pageNumber);
  };

  let loadshimmer = (
    <ContentLoader
      speed={2}
      width={"1000px"}
      height={450}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      style={{ marginLeft: -29, marginTop: -25 }}
    >
      <rect x="51" y="45" rx="3" ry="3" width="1006" height="17" />
      <circle cx="879" cy="123" r="11" />
      <circle cx="914" cy="123" r="11" />
      <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
      <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
      <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
      <rect x="55" y="155" rx="3" ry="3" width="997" height="2" />
    </ContentLoader>
  );

  return (
    <div className="drivers">
      <Header title={translate("users")} />
      <div className="drivers-header">
        <p className="partner-database">{/* translate("usersDatabase") */}</p>
      </div>
      <Titlebar
        onClick1={() => {}}
        onClick2={() => {}}
        input={input}
        onClick4={updateInput}
        active={1}
        title1={translate("users")}
      />
        {/* title2={translate("users")} */}
      {!loading ? (
        <div>
          <section className="shortlisted">
            <List from="users" data={usersList} onClick={() => history.push("/users")} />
          </section>
          <div className="campaign-pagination-bottom" style={{ justifyContent: 'flex-end' }}>
          {count > 10 ? (
            <Pagination
              firstPageText={<i className="fa fa-angle-left" aria-hidden="true"></i>}
              prevPageText={<i className="fa fa-angle-double-left" aria-hidden="true"></i>}
              lastPageText={<i className="fa fa-angle-right" aria-hidden="true"></i>}
              nextPageText={<i className="fa fa-angle-double-right" aria-hidden="true"></i>}
              activePage={activePage}
              itemsCountPerPage={10}
              totalItemsCount={count}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              activeClass="active"
              activeLinkClass="active"
              hideDisabled
            />
          ) : (
            ""
          )}
          </div>
        </div>
      ) : (
        <section className="shortlisted">{loadshimmer}</section>
      )}
    </div>
  );
};

export default User;
